__turbopack_context__.v({
  "root": "InscriptionText-module__Gyviaq__root",
});
